import {Route} from './types';
import {meta} from './meta';
import { CoverAndInheritMeta } from './utils';

// login
import Login from '@/pages/login/index.vue';

// // dashboard
// //// dashbaord
// import Dashboard from '@/pages/dashboard/index.vue';
// // campaignLive
// import CampaignLive from '@/pages/dashboard/campaign/index.vue';
// //// budget
// import DashboardBudget from '@/pages/dashboard/budget/index.vue';

// campaign
import Campaign from '@/pages/campaign/index.vue';
import Adset from '@/pages/campaign/adset/index.vue';
import Ad from '@/pages/campaign/adset/ad/index.vue';

// audience
import Audience from '@/pages/audience/index.vue';
import AudienceEdit from '@/pages/audience/editing.vue';

// adFolder
import AdFolder from '@/pages/adFolder/index.vue';
import AdFolderEdit from '@/pages/adFolder/editing.vue';

// inventory
import Inventory from '@/pages/inventory/index.vue';

// partner
import Partner from '@/pages/partner/index.vue';
import LegacyPartner from '@/pages/partner/legacy/index.vue';
import LegacyPartnerEdit from '@/pages/partner/legacy/editing.vue';

// history
import CampaignHistory from '@/pages/campaign/history.vue';
import AdsetHistory from '@/pages/campaign/adset/history.vue';

// editing
import CampaignEdit from '@/pages/campaign/editing.vue';
import AdsetEdit from '@/pages/campaign/adset/editing.vue';
import AdEdit from '@/pages/campaign/adset/ad/editing.vue';

// report
//// sales
import ReportSalesMonthly from '@/pages/report/sales/monthly/index.vue';

//// campaign 
import ReportCampaign from '@/pages/report/campaign/index.vue';
import ReportCampaignDetail from '@/pages/report/campaign/detail.vue';
import ReportAdsetDetail from '@/pages/report/campaign/adset/detail.vue';

//// inventory
import ReportInventoryHourly from '@/pages/report/inventory/hourly/index.vue';
import ReportInventoryDaily from '@/pages/report/inventory/daily/index.vue';
import ReportInventoryMonthly from '@/pages/report/inventory/monthly/index.vue';

//// ai
import ReportAI from '@/pages/report/ai/index.vue';

import ActiveInventory from '@/pages/activeInventories/index.vue';
// 404 NotFound
import NotFound from '@/pages/Error/NotFound.vue';


import * as Terms from '@/const/terms/mainTerms';

export const RootName = 'campaign'; // routes 내의 name

const routes: Route[] = [
    {
        path: '/',
        name: 'root',
        redirect: {name: RootName},
        meta: {
            auth: 'none',
            header: false,
            nav: false,
        },
    },
    // login
    {
        path: '/login',
        name: 'login',
        component: Login,
        meta: {
            auth: 'block',
            header: false,
            nav: false,
            title: Terms.Other.login.title,
        },
    },
    // // dashboard
    // //// dashboard
    // {
    //     path: '/dashboard',
    //     name: 'dashboard',
    //     component: Dashboard,
    //     meta: {
    //         title: Terms.Dashboard.dashboard.title,
    //     },
    // },
    // {
    //     path: '/dashboard/campaign',
    //     name: 'dashboard/campaign',
    //     component: CampaignLive,
    //     meta: {
    //         title: Terms.Dashboard.campaignLive.title,
    //     },
    // },
    // //// budget
    // {
    //     path: '/dashboard/budget',
    //     name: 'dashboard/budget',
    //     component: DashboardBudget,
    //     meta: {
    //         title: Terms.Dashboard.budget.title,
    //     },
    // },
    // campaign
    //// campaign
    {
        path: '/campaigns',
        name: 'campaign',
        component: Campaign,
        meta: {
            subRoot: '/campaigns',
            title: Terms.Setting.campaign.title,
        },
    },
    {
        path: '/campaigns/:campaignID/adsets',
        name: 'adset',
        component: Adset,
        meta: {
            subRoot: '/campaigns',
            title: Terms.Setting.adset.title,
        },
    },
    {
        path: '/campaigns/:campaignID/adsets/:adsetGroup/ads',
        name: 'ad',
        component: Ad,
        meta: {
            subRoot: '/campaigns',
            title: Terms.Setting.ad.title,
        },
    },
    //// audience
    {
        path: '/audiences',
        name: 'audience',
        component: Audience,
        meta: {
            title: Terms.Setting.audience.title,
        },
    },
    //// adfolder
    {
        path: '/adFolders',
        name: 'adFolder',
        component: AdFolder,
        meta: {
            title: Terms.Setting.adFolder.title,
        },
    },
    // inventory
    {
        path: '/inventorys',
        name: 'inventory',
        component: Inventory,
        meta: {
            title: Terms.Setting.inventory.title,
        },
    },
    // // partner
    // {
    //     path: '/partners',
    //     name: 'partner',
    //     component: Partner,
    //     meta: {
    //         title: Terms.Setting.partner.title,
    //     },
    // },
    // advertiser
    {
        path: '/advertisers',
        name: 'advertiser',
        component: LegacyPartner,
        meta: {
            title: Terms.Setting.advertiser.title,
        },
    },

    // history 
    {
        path: '/campaigns/:campaignID/history',
        name: 'campaignHistory',
        component: CampaignHistory,
        meta: {
            title: Terms.Setting.campaign.history.title,
            subRoot: '/campaigns',
        },
    },
    {
        path: '/campaigns/:campaignID/adsets/:adsetGroup/history',
        name: 'adsetHistory',
        component: AdsetHistory,
        meta: {
            title: Terms.Setting.adset.history.title,
            subRoot: '/campaigns',
        },
    },
    // editing
    {
        //// campaignEdit
        path: '/campaigns/:campaignID/editing',
        name: 'campaignEdit',
        component: CampaignEdit,
        meta: {
            title: Terms.Setting.campaign.editing.title,
            subRoot: '/campaigns',
        },
    },
    {
        //// campaignNew
        path: '/campaigns/new',
        name: 'campaignNew',
        component: CampaignEdit,
        meta: {
            title: Terms.Setting.campaign.new.title,
            subRoot: '/campaigns',
        },
    },
    {
        //// adsetEdit
        path: '/campaigns/:campaignID/adsets/:adsetGroup/editing',
        name: 'adsetEdit',
        component: AdsetEdit,
        meta: {
            title: Terms.Setting.adset.editing.title,
            subRoot: '/campaigns',
        },
    },
    {
        //// adsetNew
        path: '/campaigns/:campaignID/adsets/new',
        name: 'adsetNew',
        component: AdsetEdit,
        meta: {
            title: Terms.Setting.adset.new.title,
            subRoot: '/campaigns',
        },
    },
    {
        //// adInit // 의미적으로만 다르고 전부 같음 (step 안나옴)
        path: '/campaigns/:campaignID/adsets/:adsetGroup/ads/init',
        name: 'adInit',
        component: AdEdit,
        meta: {
            title: Terms.Setting.ad.init.title,
            subRoot: '/campaigns',
        }
    },
    {
        //// adEdit
        path: '/campaigns/:campaignID/adsets/:adsetGroup/ads/editing',
        name: 'adEdit',
        component: AdEdit,
        meta: {
            title: Terms.Setting.ad.editing.title,
            subRoot: '/campaigns',
        }
    },
    {
        //// audienceNew
        path: '/audiences/new',
        name: 'audienceNew',
        component: AudienceEdit,
        meta: {
            title: Terms.Setting.audience.new.title,
            subRoot: '/audiences',
        },
    },
    {
        //// audienceEdit
        path: '/audiences/:audienceID/editing',
        name: 'audienceEdit',
        component: AudienceEdit,
        meta: {
            title: Terms.Setting.audience.editing.title,
            subRoot: '/audiences',
        },
    },
    {
        //// adFolderNew
        path: '/adFolders/new',
        name: 'adFolderNew',
        component: AdFolderEdit,
        meta: {
            title: Terms.Setting.adFolder.new.title,
            subRoot: '/adFolders',
        },
    },
    {
        //// adFolderEdit
        path: '/adFolders/:adFolderID/editing',
        name: 'adFolderEdit',
        component: AdFolderEdit,
        meta: {
            title: Terms.Setting.adFolder.editing.title,
            subRoot: '/adFolders',
        },
    },
    {
        //// advertiserNew
        path: '/advertisers/new',
        name: 'advertiserNew',
        component: LegacyPartnerEdit,
        meta: {
            title: Terms.Setting.advertiser.new.title,
        },
    },
    {
        //// advertiserEdit
        path: '/advertisers/:advertiserID/editing',
        name: 'advertiserEdit',
        component: LegacyPartnerEdit,
        meta: {
            title: Terms.Setting.advertiser.editing.title,
        },
    },
    // report
    //// campaign
    {
        path: '/report/campaigns',
        name: 'reportCampaign',
        component: ReportCampaign,
        meta: {
            title: Terms.Report.campaign.title,
        },
    },
    //// campaign details
    {
        path: '/report/campaigns/:campaignID/detail',
        name: 'reportCampaignDetail',
        component: ReportCampaignDetail,
        meta: {
            title: Terms.Report.campaignDetail.title,
            subRoot: '/report/campaigns',
        },
    },
    //// adset details
    {
        path: '/report/campaigns/:campaignID/adsetDetail',
        name: 'reportAdsetDetail',
        component: ReportAdsetDetail,
        meta: {
            title: Terms.Report.adsetDetail.title,
            subRoot: '/report/campaigns',
        },
    },
    // {
    //     path: '/report/campaign/weight',
    //     name: 'reportCampaignWeight',
    //     component: CampaignWeight,
    //     meta: {
    //         title: Terms.Report.campaignWeight.title,
    //     },
    // },
    //// sales
    //// // monthly
    {
        path: '/report/sales/monthly',
        name: 'reportSalesMonthly',
        component: ReportSalesMonthly,
        meta: {
            title: Terms.Report.sales.monthly.title,
        },
    },
    //// inventory
    {
        path: '/report/inventory/hourly',
        name: 'reportInventoryHourly',
        component: ReportInventoryHourly,
        meta: {
            title: Terms.Report.inventory.hourly.title,
        },
    },
    {
        path: '/report/inventory/daily',
        name: 'reportInventoryDaily',
        component: ReportInventoryDaily,
        meta: {
            title: Terms.Report.inventory.daily.title,
        },
    },
    {
        path: '/report/inventory/monthly',
        name: 'reportInventoryMonthly',
        component: ReportInventoryMonthly,
        meta: {
            title: Terms.Report.inventory.monthly.title,
        },
    },
    //// ai
    {
        path: '/report/ai',
        name: 'reportAi',
        component: ReportAI,
        meta: {
            title: Terms.Report.ai.title,
        },
    },
    {
        path: '/activeInventories',
        name: 'activeInventory',
        component: ActiveInventory,
        meta: {
            title: Terms.Setting.activeInventory.title,
        },
    },
    {
        path: '**',
        name: '404',
        component: NotFound,
        meta: {
            auth: 'none',
            nav: false,
            header: false,
            title: Terms.Other.notFount.title,
        },
    },
];

CoverAndInheritMeta(routes, meta);

export default routes;
